import React from 'react'
import PropTypes from 'prop-types'
import content from 'pp-react-l10n'
import glamorous from 'glamorous'
import { trackLinkWithData } from '../../lib/analytics/fpti'
import { smallAndSmaller, extraSmallAndSmaller } from 'lib/styles/media-queries'

let i18n = content('transfer/inc/currencyConversion')

const Title = glamorous.div(
  {
    fontSize: '24px',
    textAlign: 'center',
    margin: '40px 0 15px 0',
    [smallAndSmaller]: {
      fontSize: '22.5px',
      margin: '20px 0 10px 0',
    },
  },
  'ppvx_text--xl2'
)

const ConvertorBox = glamorous.div(
  {
    border: 'solid 2px #cbd2d6',
    borderRadius: '14.5px',
    width: '382px',
    margin: 'auto',
    position: 'relative',
    cursor: 'pointer',
    [smallAndSmaller]: {
      width: '316px',
    },
  },
  ({ isSelected }) => isSelected && { border: 'solid 2px #00cf92' }
)

const ConvertorContent = glamorous.div({
  padding: '20px',
  [smallAndSmaller]: {
    padding: '15px',
  },
})

const Convertor = glamorous.span('ppvx_text--md ppvx_text--medium', {
  position: 'relative',
  top: '-6px',
  left: '2px',
})

const ExchangeRate = glamorous.div(
  {
    margin: '5px 0',
    color: '#000000',
  },
  'ppvx_text--md'
)

const RateInfo = glamorous.div('ppvx_text--md', {
  lineHeight: '1.47',
  [smallAndSmaller]: {
    fontSize: '13px',
  },
})

const Checkmark = glamorous.div(
  'ppvx_icon ppvx_icon--size_lg ppvx_icon-check',
  {
    position: 'absolute',
    top: '-7px',
    right: '-6px',
    color: '#00cf92',
    background: '#ffffff',
  }
)

const ButtonDiv = glamorous.div({
  textAlign: 'center',
  marginTop: '45px',
  [smallAndSmaller]: {
    marginTop: '30px',
  },
})

const Button = glamorous.button('ppvx_btn', {
  width: '44%',
  [extraSmallAndSmaller]: {
    width: '89%',
  },
})

const OptionDiv = glamorous.div({
  maxWidth: '382px',
  margin: 'auto',
})

export class BFXCurrencyConversion extends React.Component {
  static propTypes = {
    ppCurrencyExchange: PropTypes.object.isRequired,
    currencyDecimal: PropTypes.string.isRequired,
    selectedFundingOption: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    closeCurrencyConversionOverpanel: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    const { currency_exchange } = props.selectedFundingOption

    this.state = {
      selectedOption: currency_exchange ? 'INTERNAL' : 'EXTERNAL',
    }
  }

  renderCheckmark = () => {
    return <Checkmark />
  }

  handleOptionChange = event => {
    this.setState({
      selectedOption: event.target.value,
    })
  }
  handleSubmit = event => {
    event.preventDefault()
    event.stopPropagation()

    const { currency_exchange } = this.props.selectedFundingOption
    const currentCurrencyConversionOption = currency_exchange
      ? 'INTERNAL'
      : 'EXTERNAL'

    // track default and selection
    const pageGroup = 'main:consumer:p2p:transfer:currencyConversionOption'
    const pageName =
      'main:consumer:p2p:transfer:currencyConversionOption:::node'

    const extraData = {
      opsel: this.state.selectedOption,
      dflopt: currentCurrencyConversionOption,
    }
    trackLinkWithData('next', pageGroup, pageName, extraData, 'link')

    // if user has not selected different option, close overpanel and return out
    if (currentCurrencyConversionOption === this.state.selectedOption) {
      return this.props.closeCurrencyConversionOverpanel()
    }

    this.props.handleSubmit(this.state.selectedOption)
  }

  renderPayPalConvertor = (isPPConvertor, paypalExchangeRateData) => {
    return (
      <ConvertorBox isSelected={isPPConvertor}>
        {isPPConvertor && this.renderCheckmark()}
        <ConvertorContent>
          <div data-nemo="internal-conversion-label">
            <span
              className="ppvx_icon ppvx_icon--size_md ppvx_icon-logo-paypal"
              style={{ color: '#0070ba', position: 'relative', top: '2px' }}
            />
            <Convertor>{i18n('currencyConversion.paypal')}</Convertor>
          </div>
          <ExchangeRate>
            {i18n.html(
              'currencyConversion.paypalExchangeRate',
              paypalExchangeRateData
            )}
          </ExchangeRate>
          <RateInfo>{i18n('info.simpleFeeDisclaimer')}</RateInfo>
        </ConvertorContent>
      </ConvertorBox>
    )
  }

  renderCardConvertor = isCardConvertor => {
    return (
      <ConvertorBox isSelected={isCardConvertor}>
        {isCardConvertor && this.renderCheckmark()}
        <ConvertorContent>
          <div className="ppvx_text--md ppvx_text--medium">
            {i18n('currencyConversion.cardIssuer')}
          </div>
          <ExchangeRate>
            {i18n('currencyConversion.cardExchangeRate')}
          </ExchangeRate>
          <RateInfo>{i18n('options.newCreditCardExchangeRate')}</RateInfo>
        </ConvertorContent>
      </ConvertorBox>
    )
  }
  render() {
    let {
      exchange_funds_in: { currency_code: fundingOptionCurrencyCode = '' } = {},
      exchange_rate = '',
      exchange_funds_out: { currency_code: ToCurrencyCode = '' },
    } = this.props.ppCurrencyExchange

    const rate = exchange_rate
      .toString()
      .replace('.', this.props.currencyDecimal)

    let paypalExchangeRateData = {
      fundingOptionCurrencyCode: fundingOptionCurrencyCode,
      rate,
      currencyCode: ToCurrencyCode,
    }

    let isPPConvertor = this.state.selectedOption === 'INTERNAL'

    return (
      <div>
        <Title data-testid="currency-convertor-title">
          {i18n('currencyConversion.chooseCurrencyConverter')}
        </Title>
        <form onSubmit={this.handleSubmit}>
          <OptionDiv>
            <label>
              <input
                data-testid="convert-with-paypal"
                type="radio"
                name="currency-convertor"
                value="INTERNAL"
                style={{ opacity: 0 }}
                checked={this.state.selectedOption === 'INTERNAL'}
                onChange={this.handleOptionChange}
              />
              {this.renderPayPalConvertor(
                isPPConvertor,
                paypalExchangeRateData
              )}
            </label>
          </OptionDiv>
          <OptionDiv>
            <label>
              <input
                data-testid="convert-with-card"
                type="radio"
                name="currency-convertor"
                value="EXTERNAL"
                style={{ opacity: 0 }}
                checked={this.state.selectedOption === 'EXTERNAL'}
                onChange={this.handleOptionChange}
              />
              {this.renderCardConvertor(!isPPConvertor)}
            </label>
          </OptionDiv>
          <ButtonDiv>
            <Button
              data-testid="currency-conversion-next"
              data-nemo="currency-conversion-next"
              type="submit"
            >
              {i18n('options.continue')}
            </Button>
          </ButtonDiv>
        </form>
      </div>
    )
  }
}
